import API from 'shared/constants/api';
import queryString from 'query-string';
import difference from 'lodash/difference';
import snakeCaseKeys from 'snakecase-keys';
import pick from 'lodash/pick';
import omit from 'lodash/omit';
import { generateSearchQuery } from 'shared/helpers/urls';
import { SEARCH_SNAKE_KEYS_EXCLUDE } from 'shared/constants/search';
import anyMake from 'shared/constants/json/anyMake.json';
import { getRootTransportType } from 'shared/helpers/transportTypes';
import { ANY_TYPE_OMITTED_FIELDS, OMMITED_FIELDS_BY_TRANSPORT_ID } from 'shared/constants/adverts';

export const isCanBeRedirected = params => {
  if (params.seoQuery && params.seoQuery.active === true) return false;
  const urlPath = (params.url || '').split('/').filter(item => item);
  // If this is /avto/{country} we should not fire redirect.
  if (
    urlPath.length === 2 &&
    urlPath[0] === 'avto' &&
    urlPath[1] === (params.location && params.location.slug)
  ) {
    return false;
  }
  return true;
};

export const fetchVocabulary = async (vocabulary, transportType, fetch, customVc = []) => {
  const rootTransportType = getRootTransportType(transportType);
  const slug = rootTransportType && rootTransportType.slug;

  const isMotoSearch = ['moto', 'mototsikl'].includes(slug);
  const isAuto = slug === 'avto';
  // const vocabularytoFetch = ['makes', 'drives', 'engines', 'categories', 'gearboxes'];

  let missingVocabularyFields = Object.keys(vocabulary).filter(
    key =>
      !vocabulary[key] ||
      key === 'makes' ||
      isMotoSearch ||
      (customVc.length && customVc.includes(key)),
  );

  if (isAuto) {
    missingVocabularyFields = difference(missingVocabularyFields, [
      'packages',
      'rubrics',
      'types',
      'engineOrders',
      'tacts',
      'unloadings',
      'options',
    ]);
  }

  const fetchedVocabulary = await Promise.all(
    missingVocabularyFields.map(field =>
      API.VOCABULARY[field]
        ? fetch(API.VOCABULARY[field](transportType.id))
            .then(r => r.json())
            .then(response => ({ [field]: response }))
        : Promise.resolve({}),
    ),
  );

  const mergedVocabulary = fetchedVocabulary.reduce(
    (results, pair) => ({ ...results, ...pair }),
    {},
  );

  if (Array.isArray(mergedVocabulary.makes)) {
    mergedVocabulary.makes.unshift(anyMake);
  }

  return mergedVocabulary;
};

export function getSearchQuery(query) {
  const qObject = generateSearchQuery(query);
  if (qObject.make && qObject.make === -1) {
    delete qObject.make;
  }
  const withExcluded = pick(qObject, SEARCH_SNAKE_KEYS_EXCLUDE);
  const withputExcluded = omit(qObject, SEARCH_SNAKE_KEYS_EXCLUDE);
  const q = snakeCaseKeys(withputExcluded);
  return { ...q, ...withExcluded };
}

export const fetchMakesCounter = async (transportId, fetch) => {
  const result = await fetch(`${API.ADVERT.MAKES_COUNT}?transport=${transportId}`).then(r =>
    r.json(),
  );
  return result;
};

export const fetchVipCars = async (fetch, pages) => {
  let specialCars;
  // const PRICE_FROM = 1000000;
  // const CARS_IN_LIST = 20;
  // const LITVA_ID = 4482;
  const CURRENT_TRANSPORT_ID = 1;
  const params = {
    is_vip: true,
    transport: CURRENT_TRANSPORT_ID,
  };
  const omitQuery = [
    ...ANY_TYPE_OMITTED_FIELDS,
    ...(OMMITED_FIELDS_BY_TRANSPORT_ID[CURRENT_TRANSPORT_ID] || []),
  ];
  if (pages) params.perPage = pages;

  const vipParam = getSearchQuery(params);
  const q = `?omit=${omitQuery}&${queryString.stringify(vipParam)}`;
  const promisesToAwait = [];

  promisesToAwait.push(
    Promise.all([fetch(API.ADVERT.ALL(q)).then(r => r && r.json && r.json())]).then(allResults => {
      const [vipCars] = allResults;
      specialCars = {
        vipCars,
        lowPriceCars: [],
        europeCars: [],
      };
    }),
  );
  try {
    await Promise.all(promisesToAwait);
  } catch (err) {
    console.log(err);
  }
  return specialCars;
};

function parseQuery(params) {
  if (typeof params === 'string') return Object.fromEntries(new URLSearchParams(params));
  return params;
}

export const fetchAdvertsWithOmit = async (fetch, params, pages) => {
  let result = null;
  const CURRENT_TRANSPORT_ID = 1;
  const CURRENCY = 'usd';
  const paramsObject = parseQuery(params);

  const qParams = {
    ...paramsObject,
    transport: paramsObject.transport || CURRENT_TRANSPORT_ID,
    currency: paramsObject.currency || CURRENCY,
  };
  const omitQuery = [
    ...ANY_TYPE_OMITTED_FIELDS,
    ...(OMMITED_FIELDS_BY_TRANSPORT_ID[CURRENT_TRANSPORT_ID] || []),
  ];
  if (pages) qParams.perPage = pages;

  const q = `?omit=${omitQuery}&${queryString.stringify(getSearchQuery(qParams))}`;
  // console.log(' query >> ', q);
  try {
    result = await fetch(API.ADVERT.ALL(q)).then(r => r && r.json && r.json());
  } catch (err) {
    console.error(err.message);
  }
  return result;
};



// WEBPACK FOOTER //
// ./src/shared/helpers/search.js